import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';

@Component({})
export default class SAFormLabel extends Mixins(BASEComponentVue) {
    @Prop({
        type: String,
        default: "",
    })
    public title!: string;

    @Prop({
        type: Boolean,
        default: false,
    })
    public required!: boolean;

    @Prop({
        type: String,
        default: "",
    })
    public error!: string;

}
